var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('crud',{ref:"crud",attrs:{"config":_vm.config},on:{"handle1":_vm.handleReport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }